// Module
var code = `<!-- UserView -->
<div>
	<div class="cf"></div>
	<div class="non-admin-actions">
		<div class="languages hide">
		    <a id="languageDropdown" type="button" class="btn btn-default" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
		      <i class="fa fa-language" title="Languages"></i>
		    </a>
		    <div class="dropdown-menu old languages-menu" aria-labelledby="languageDropdown"></div>
	  	</div>
		<a href="//docs.graphileon.com" target="_blank" class="btn btn-default documentation"><i class="fa fa-book" title="Documentation"></i></a>
		<a class="btn btn-default log-off"><i class="fa fa-sign-out-alt" title="Log out"></i></a>
	</div>

	<div class="actions">
		<a href="/settings/" class="btn btn-default settings hide"><i class="fa fa-cogs" title="Settings"></i></a>
		<a class="btn btn-default licensecheck hide"><i class="fa fa-file-alt" title="Check License"></i></a>

		<a class="btn btn-default shortcuts-toggle team" style="float: right;">
			<i class="fa fa-users" title="Toggle team shortcuts"></i>
		</a>
		<a class="btn btn-default shortcuts-toggle user" style="float: right;">
			<i class="fa fa-user" title="Toggle personal shortcuts"></i>
		</a>
	</div>
	<div class="shortcuts">
		<div class="shortcuts-user shortcuts-section hide">
			<i class="shortcuts-section-icon fa fa-user" title="User shortcuts"></i>
		</div>
		<div class="shortcuts-team shortcuts-section hide">
			<i class="shortcuts-section-icon fa fa-users" title="Team shortcuts"></i>
		</div>
		<div class="shortcuts-dashboard shortcuts-section">
			<div class="dashboards">
				<i class="shortcuts-section-icon fa fa-dashboard" title="Dashboard"></i>
				<select id="dashboard-selector" class="dashboard-selector"></select>
			</div>
		</div>
	</div>
	<!-- /UserView -->
</div>
`;
// Exports
export default code;